module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pl":{"amountFilter":"Suma sprzedaży","quantityFilter":"Liczba [sztuk]","impressionsFilter":"Wyświetlenia ofert","clicksFilter":"Kliknięcia"}}')
  delete Component.options._Ctor
}
